export default "__VITE_ASSET__Cu4m20bZ__"